import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Input, ViewChild } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { ForbrugsnotifikationUdsendelseIndstilling } from "../model/forbrugsnotifikation-indstillinger.model";
import { ForbrugsnotifikationType } from "../model/forbrugsnotifikation-opsaetning.model";
import { MatButtonToggleGroup } from "@angular/material/button-toggle";

@Component({
    selector: "forbrugsnotifikation-udsendelse",
    templateUrl: "./forbrugsnotifikation-udsendelse.component.html",
    styleUrls: ["./forbrugsnotifikation-udsendelse.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForbrugsnotifikationUdsendelseComponent {
    public type = { brev: ForbrugsnotifikationType.brev, mail: ForbrugsnotifikationType.mail, sms: ForbrugsnotifikationType.sms };

    @Input() public formGroup: UntypedFormGroup;
    @Input() public indstillinger: ForbrugsnotifikationUdsendelseIndstilling;

    @ViewChild("messagePickerGroup") messagePickerGroup: ElementRef;
    @ViewChild("messageTypeGroup") messageTypeGroup: ElementRef;

    ngAfterViewInit() {
        const pickerFocusableElements = this.messagePickerGroup.nativeElement.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        const typeFocusableElements = this.messageTypeGroup.nativeElement.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        pickerFocusableElements.forEach((element, index) => {
            element.addEventListener("keydown", (event: KeyboardEvent) => {
                let newIndex: number;
                switch (event.key) {
                    case "ArrowRight":
                    case "ArrowDown":
                        event.preventDefault();
                        newIndex = index + 1 >= pickerFocusableElements.length ? 0 : index + 1;
                        break;
                    case "ArrowLeft":
                    case "ArrowUp":
                        event.preventDefault();
                        newIndex = index - 1 < 0 ? pickerFocusableElements.length - 1 : index - 1;
                        break;
                    default:
                        return;
                }
                pickerFocusableElements[newIndex].focus();
            });
        });

        typeFocusableElements.forEach((element, index) => {
            element.addEventListener("keydown", (event: KeyboardEvent) => {
                let newIndex: number;
                switch (event.key) {
                    case "ArrowRight":
                    case "ArrowDown":
                        event.preventDefault();
                        newIndex = index + 1 >= typeFocusableElements.length ? 0 : index + 1;
                        break;
                    case "ArrowLeft":
                    case "ArrowUp":
                        event.preventDefault();
                        newIndex = index - 1 < 0 ? typeFocusableElements.length - 1 : index - 1;
                        break;
                    default:
                        return;
                }
                typeFocusableElements[newIndex].focus();
            });
        });
    }
}
